<div class="modal-header">
    <h4 class="modal-title">{{ isNew ? 'Add Supplier Lookup' : 'Edit Supplier Lookup' }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
    @if (errorMessage) {
        <div class="alert alert-danger py-1 px-2 mb-2">{{ errorMessage }}</div>
    }
    <form #supplierLookupForm="ngForm">
        <!-- Site ID -->
        <div class="form-group row mb5">
            <label for="siteId" class="col-sm-3 col-form-label">Site ID <span class="req-color">*</span></label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="siteId" name="siteId"
                    [(ngModel)]="model.siteId" [readonly]="!isNew" required>
            </div>
        </div>

        <!-- Supplier ID -->
        <div class="form-group row mb5">
            <label for="supplierId" class="col-sm-3 col-form-label">Supplier ID <span class="req-color">*</span></label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="supplierId" name="supplierId"
                    [(ngModel)]="model.supplierId" required>
            </div>
        </div>

        <!-- Site Name -->
        <div class="form-group row mb5">
            <label for="siteName" class="col-sm-3 col-form-label">Site Name</label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="siteName" name="siteName"
                    [(ngModel)]="model.siteName">
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-outline-dark" (click)="save()"
        [disabled]="isSaving || !supplierLookupForm.valid">
        @if (isSaving) {
            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        }
        Save
    </button>
</div>
